import { css } from "@emotion/css";

import { getTextStyle } from "../../foundations/typography/styles";

export function useInputStyles() {
  return sharedStyles.input;
}

export function useCardInputStyles() {
  return sharedStyles.card;
}

export const sharedStyles = {
  input: css(getTextStyle("input/text-field"), {
    width: "100%",
    textAlign: "left",
    border: "none",
    borderRadius: "var(--border-radius-2)",
    outline: "none",
    paddingBottom: "var(--space-2)",
    paddingLeft: "var(--space-3)",
    paddingRight: "var(--space-3)",
    paddingTop: "var(--space-2)",
    color: "var(--text-base)",
    boxSizing: "border-box",
    backgroundColor: "var(--background-input)",
    boxShadow: `inset 0 0 0 1px var(--border-input)`,
    "::placeholder": { color: "var(--text-placeholder)" },
    "&[data-hovered]": {
      boxShadow: `inset 0 0 0 1px var(--border-input-hover)`,
    },
    "&[data-focused]": {
      boxShadow: "var(--focus-input)",
    },
    "&[data-invalid]": css({
      boxShadow: `inset 0 0 0 1px var(--border-danger-input)`,
      "&[data-focused]": {
        boxShadow: "var(--focus-input-error)",
      },
    }),
    "&[data-disabled], &[aria-disabled]": {
      boxShadow: `inset 0 0 0 1px var(--border-input-disabled)`,
      backgroundColor: "var(--background-input-disabled)",
      color: "var(--text-weak)",
      "::placeholder": { color: "var(--text-disabled)" },
    },
    "&input&:read-only": {
      color: "var(--text-weak)",
    },
  }),
  card: css({
    flexDirection: "row-reverse",
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: "var(--border-radius-3)",
    alignItems: "center",
    padding: "var(--space-3)",
    justifyContent: "space-between",
    borderColor: "var(--border-base)",
    "&[data-hovered]": { borderColor: "var(--border-input-hover)" },
    "&[data-selected]": { borderColor: "var(--border-input-active)" },
    "&[data-disabled]": {
      borderColor: "var(--border-input-disabled)",
    },
    "&[data-focused]": {
      boxShadow: "var(--focus-action)",
    },
  }),
  basicCard: css({
    padding: "var(--space-3)",
    borderRadius: "var(--border-radius-3)",
    justifyContent: "space-between",
    "&:focus, &:hover": css({
      outline: "0",
    }),
  }),
  field: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
    minWidth: 80,
    // maxWidth: 416,
  }),
  noBorder: css({
    border: "none",
  }),
};
